// extracted by mini-css-extract-plugin
module.exports = {"color1":"#faa640","color2":"#ea323b"};